// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UgPcxZFC_lQMcDapjUYg{width:100%}.z0eC0gt9fqgypcqvRhM6{flex-direction:column;justify-content:flex-start;gap:4px;display:flex}.r2B8drlbpRoxHc_ve3Vc{padding-top:4px;padding-bottom:4px}.Eixr3fQDjK0SR7e791lN{flex-direction:column;gap:4px;padding:8px 12px;display:flex}.xqOykGfnWgYPCtVDBv8D{justify-content:space-between;padding-right:5px;display:flex}.MgdxwGQAo5Z8zkb7Ykww{padding:8px}.tuN5TXDV9s0ZdGjawbp8{color:var(--light-blue-60)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `UgPcxZFC_lQMcDapjUYg`,
	"trigger": `z0eC0gt9fqgypcqvRhM6`,
	"input": `r2B8drlbpRoxHc_ve3Vc`,
	"list": `Eixr3fQDjK0SR7e791lN`,
	"titleWrapper": `xqOykGfnWgYPCtVDBv8D`,
	"title": `MgdxwGQAo5Z8zkb7Ykww`,
	"selectAllButton": `tuN5TXDV9s0ZdGjawbp8`
};
export default ___CSS_LOADER_EXPORT___;
